import React from "react";
import "./MetaverseGame.css";
const MetaverseGame = () => {
  return (
    <div>
      <main id="metaverse_game_main">
        <section className="metaverse_game_banner">
          <div className="container-fluid cus_container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-7 col-12 p-0">
                <img
                  src="./images/game-development-by-metakop-gaming-devlopment-company12.webp"
                  alt="Metaverse-Game-Development-Company"
                  title="Metaverse Game Development Company"
                  className="banner_img img-fluid"
                />
              </div>
              <div className="col-lg-5 col-12">
                <div style={{ marginTop: "10vh" }} className="banner_contsec">
                  <h1 className="ourservice-titles-new">
                    <span className="cus_brn_title">Metaverse Game</span>
                    <br /> DEVELOPMENT COMPANY
                  </h1>
                  <p className="contents">
                    Welcome to the future of gaming in the metaverse! Our
                    Metaverse game development platform combines creativity and
                    technology to provide game makers of all skill levels
                    endless options.
                  </p>
                  <div className="HddrBtns banner_btn_sec">
                    <button
                      toggle="modal"
                      target="#popup_form_modal"
                      className="btn BtnPrimry TlkBtn banner_btn"
                    >
                      <span>
                        <img
                          src="./images/metaverseimage1.webp"
                          alt="enquiry"
                          loading="eager"
                          className="img-fluid lazyload mr-2 lazyload"
                        />
                        Get A Live Quote
                      </span>
                      <span>
                        <img
                          src="./images/metaverseimage5.webp"
                          alt="enquiry"
                          loading="eager"
                          className="img-fluid lazyload mr-2"
                        />
                        Get A Live Quote
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_sec">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5 col-12">
                <h2 className="title">Metaverse Game Development</h2>
                <p className="contents">
                  Metaverse game development has the creation of immersive ,
                  shared virtual world which can be allowed through several
                  players. MetaBlock, a forerunner in Metaverse game development ,
                  will offer you a cutting-edge Metaverse game. We offer a
                  fantastic gaming platform to customers worldwide with the help
                  of a team of professionals that are well-versed in blockchain
                  technology. Our developers have years of experience creating
                  metaverse games on several blockchain networks like Ethereum,
                  Solana , Binance Smart chain, Polygon, Cardano, Avalanche,
                  etc.
                </p>
                <div className="HddrBtns metaverse_game_btn_sec">
                  <button
                    toggle="modal"
                    target="#popup_form_modal"
                    className="btn BtnPrimry TlkBtn metaverse_game_btn "
                  >
                    <span className="">
                      <img
                        src="./images/game-development-by-metakop-gaming-devlopment-company13.webp"
                        alt="enquiry"
                        loading="eager"

                      />
                      Talk To Our Expert
                    </span>
                    <span>
                      <img
                        src="./images/game-development-by-metakop-gaming-devlopment-company13.webp"
                        alt="enquiry"
                        loading="eager"
                        className="img-fluid lazyload mr-2"
                      />
                      Talk To Our Expert
                    </span>
                  </button>
                </div>
              </div>
              <div className="col-lg-7 col-12">
                <img
                  style={{ width: "100%" }}
                  src="./images/game-development-by-metakop-gaming-devlopment-company13.webp"
                  alt="Metaverse Game Development"
                  title="Metaverse Game Development"
                  className="img-fluid lazyload metav_game_dev_img"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_whatsec">
          <div className="container">
            <div className="row justify-content-center">
              {/* <div className="col-lg-12 col-12">
                <img
                  style={{ width: "60%" }}
                  src="./images/banner-img-5.webp"
                  alt="Metaverse Game Development"
                  title="Metaverse Game Development"
                  className="img-fluid lazyload"
                />
              </div> */}
              <div className="col-lg-12 col-12">
                <h2 style={{ textAlign: "center", width: "100%" }} className="title">What is Metaverse Game ?</h2>
                <p className="contents">
                  A type of online multiplayer game known as a "metaverse game" allows participants to participate in a shared virtual environment. Avatars created specifically for a metaverse game are used by players to communicate with other players in real time. The game environment is often limitless and provides players with a wide range of activities, including player engagement, virtual world exploration, mission fulfillment, and defeating other players.

                </p>
                <p className="contents">
                  Metaverse games allow players to create and modify both their virtual avatar and world, offering a high degree of customisation. They might also have a virtual marketplace where players can trade in-game currency for virtual goods.As technology advances, metaverse games are expected to become more and more popular and complicated, providing players with experiences

                </p>
                <div className="met_game_what_about_btn_sec">
                  <a
                    href="https://web.whatsapp.com/send?phone=919442164852&text=Hi,%20I%20need%20more%20details%20about%20MetaBlock%20software%20development%20services.%20Shall%20we%20discuss%20now?%20-%20https://www.MetaBlocktechnologies.com/metaverse-game-development"
                    className="btn met_game_what_about_btn desktop"
                    target="_blank"
                  >
                    <i className="fab fa-whatsapp" />
                    &nbsp;WhatsApp
                  </a>
                  <a
                    href="https://api.whatsapp.com/send?phone=919442164852&text=Hi,%20I%20need%20more%20details%20about%20MetaBlock%20software%20development%20services.%20Shall%20we%20discuss%20now?%20-%20https://www.MetaBlocktechnologies.com/metaverse-game-development"
                    className="btn met_game_what_about_btn mobile"
                    target="_blank"
                  >
                    <i className="fab fa-whatsapp" />
                    &nbsp;WhatsApp
                  </a>
                  <a
                    href="https://telegram.me/MetaBlock_Tech"
                    className="btn met_game_what_about_btn1"
                    target="_blank"
                  >
                    <i className="fab fa-telegram" />
                    &nbsp;Telegram
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_comp">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-12 metaverse_game_comp_cardsec">
                <div id="metaverse_game_comp_card">
                  <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">Metaverse Game Development company</h2>
                  <p className="contents">
                    Being the top Metaverse game development company, MetaBlock works with a variety of tech stacks, including Blender and Unreal Engine, to give consumers a seamless gaming experience. Our developers have put in many hours to produce the greatest metaverse game, one that is polished enough to draw in plenty of new players and entice returning players to start exploring the platform's broad array of gaming options. One of the first companies in the metaverse industry, MetaBlock has been using cutting-edge technologies to construct the digital world.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_services">
          <div className="container">
            <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">Our Metaverse Game development services</h2>
            <p className="contents">
              We offer end-to-end solutions to help you enter and participate in
              the metaverse. List of our services are
            </p>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-12">
                <a
                  href="https://www.MetaBlocktechnologies.com/blog/metaverse-3d-space-development"
                  target="_blank"
                >
                  <div className="service_box">
                    <div className="img_sec">
                      <img
                        src="./images/virtual-reality.webp"
                        alt="3D Space Development"
                        title="3D Space Development"
                        className="sprite_icons lazyload"
                      />
                    </div>
                    <h3 className="sub_title">3D Space Development</h3>
                    <p className="sub_contents">
                      Our team of skilled game developers adapts to varying game
                      requirements by utilizing a range of technology stacks,
                      allowing them to design distinctive 3D landscapes and maps
                      for various games.
                    </p>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <a
                  href="https://www.MetaBlocktechnologies.com/play-to-earn-game-development"
                  target="_blank"
                >
                  <div className="service_box">
                    <div className="img_sec">
                      <img
                        src="./images/mobile-money.webp"
                        alt="Play to Earn Game Development"
                        title="Play to Earn Game Development"
                        className="sprite_icons lazyload"
                      />
                    </div>
                    <h3 className="sub_title">Play to Earn Game Development</h3>
                    <p className="sub_contents">
                      The implementation of blockchain has revolutionized the
                      user's experience by offering a range of features, such as
                      play-to-earn which comprises move-to-earn, create-to-earn,
                      stake-to-earn, and more.
                    </p>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <a
                  href="https://www.MetaBlocktechnologies.com/game-development-company"
                  target="_blank"
                >
                  <div className="service_box">
                    <div className="img_sec">
                      <img
                        src="./images/customization.webp"
                        alt="Custom Games Development"
                        title="Custom Games Development"
                        className="sprite_icons lazyload"
                      />
                    </div>
                    <h3 className="sub_title">Custom Games Development</h3>
                    <p className="sub_contents">
                      We bring your unique ideas to life, tailoring every aspect
                      of the game to your vision. From captivating storylines to
                      engaging gameplay mechanics, our team of experts will
                      craft a one-of-a-kind gaming experience that resonates
                      with your audience.
                    </p>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <a
                  href="https://www.MetaBlocktechnologies.com/nft-game-development"
                  target="_blank"
                >
                  <div className="service_box">
                    <div className="img_sec">
                      <img
                        src="./images/game (1).webp"
                        alt="NFT Game Development"
                        title="NFT Game Development"
                        className="sprite_icons lazyload"
                      />
                    </div>
                    <h3 className="sub_title">NFT Game Development</h3>
                    <p className="sub_contents">
                      In regards to game development, the developers are
                      actively working towards integrating NFTs into the
                      gameplay by utilizing them as game assets, which is
                      essential for Metaverse games.
                    </p>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <a
                  href="https://www.MetaBlocktechnologies.com/blog/metaverse-avatar-development"
                  target="_blank"
                >
                  <div className="service_box">
                    <div className="img_sec">
                      <img
                        src="./images/airplane.webp"
                        alt="3D Avatar Development"
                        title="3D Avatar Development"
                        className="sprite_icons lazyload"
                      />
                    </div>
                    <h3 className="sub_title">3D Avatar Development</h3>
                    <p className="sub_contents">
                      Immerse yourself in the metaverse like never before with
                      our cutting-edge technology that offers customizable
                      hyper-realistic3D avatars for games, real estate
                      transactions, NFT trading platforms, educational pursuits,
                      and countless other exciting experiences.
                    </p>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <a
                  href="https://www.MetaBlocktechnologies.com/blog/metaverse-nft-marketplace-development"
                  target="_blank"
                >
                  <div className="service_box">
                    <div className="img_sec">
                      <img
                        src="./images/avatar.webp"
                        alt="Metaverse Marketplace Development"
                        title="Metaverse Marketplace Development"
                        className="sprite_icons lazyload"
                      />
                    </div>
                    <h3 className="sub_title">
                      Metaverse Marketplace Development
                    </h3>
                    <p className="sub_contents">
                      Our expert team specializes in crafting dynamic
                      marketplaces that empower gamers to trade, buy, and sell
                      in-game assets with ease. Unlock a world of limitless
                      opportunities as you navigate a thriving marketplace
                      ecosystem, connecting with fellow players and discovering
                      rare treasures.
                    </p>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <a
                  href="https://www.MetaBlocktechnologies.com/contact-us"
                  target="_blank"
                >
                  <div className="service_box">
                    <div className="img_sec">
                      <img
                        src="./images/gaming (1).webp"
                        alt="Gaming dApps"
                        title="Gaming dApps"
                        className="sprite_icons lazyload"
                      />
                    </div>
                    <h3 className="sub_title">Gaming dApps</h3>
                    <p className="sub_contents">
                      Immerse yourself in a decentralized world where players
                      have true ownership of in-game assets, seamless
                      peer-to-peer transactions, and transparent gameplay. Our
                      gaming dApps leverage blockchain technology to
                      revolutionize the gaming industry, offering secure, fair,
                      and interactive experiences.
                    </p>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <a
                  href="https://www.MetaBlocktechnologies.com/contact-us"
                  target="_blank"
                >
                  <div className="service_box">
                    <div className="img_sec">
                      <img
                        src="./images/exchange.webp"
                        alt="Decentralized Gaming Platform"
                        title="Decentralized Gaming Platform"
                        className="sprite_icons lazyload"
                      />
                    </div>
                    <h3 className="sub_title">Decentralized Gaming Platform</h3>
                    <p className="sub_contents">
                      Decentralized gaming platform, has various aspects of
                      gaming such as game development, item ownership, player
                      interactions, and rewards distribution are governed by
                      smart contracts and recorded on a distributed ledger.
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        <section className="game_dev_comp_techstack">
          <div className="container">
            <div className="Admin-control-main-container">
              <h4>Online Metaverse Games Features</h4>
              <div className="Admin-control-inner-container">
                <div className="a-card card-discover card1 col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper">
                        <img src="./images/Play-with-your-friends.webp" alt="Play with your friends" />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      Play with your friends
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>
                <div className="a-card card-discover card1 col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper">
                        <img
                          src="./images/Play-Online-with-real-money.webp"
                          alt="Play Online with real money"
                        />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      Play Online with real money
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>

                <div className="a-card card-discover col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper">
                        <img src="./images/Play-with-Computer.webp" alt="Play with Computer" />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      Play with Computer
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>

                <div className="a-card card-discover col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper">
                        <img src="./images/Play-with-timer.webp" alt="Play with timer" />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">Play with timer</h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>
              </div>
              <div className="Admin-control-inner-container">
                <div className="a-card card-discover card1 col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper ">
                        <img src="./images/Daily-Bonus.webp" alt='Daily Bonus' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">Daily Bonus</h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>
                <div className="a-card card-discover card1 col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper ">
                        <img src="./images/Live-Chat.webp" alt='Live Chat' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text"> Live Chat</h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>

                <div className="a-card card-discover col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper">
                        <img src="./images/Refer-&-Earn.webp" alt='Refer & Earn' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">Refer & Earn</h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>

                <div className="a-card card-discover col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper ">
                        <img
                          src="./images/Quick-Deposit-&-Withdraw-money.webp"
                          alt='Quick Deposit & Withdraw money'
                        />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      {" "}
                      Quick Deposit & Withdraw money
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>
              </div>
              <div className="Admin-control-inner-container">
                <div className="a-card card-discover card1 col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper ">
                        <img src="./images/Game-history.webp" alt='Game History' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">Game History</h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>
                <div className="a-card card-discover card1 col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper ">
                        <img src="./images/Auto-move.webp" alt='Auto move' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text"> Auto move</h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>

                <div className="a-card card-discover col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper">
                        <img
                          src="./images/Deposit-&-withdraw-history.webp"
                          alt='Deposit & withdraw history'
                        />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      Deposit & withdraw history
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>

                <div className="a-card card-discover col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper ">
                        <img src="./images/Live-Support-feature.webp" alt='Live Support features' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      Live Support features
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>
              </div>
              <div className="Admin-control-inner-container">
                <div className="a-card card-discover card1 col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper ">
                        <img src="./images/Mobile-and-email-login.webp" alt=' Mobile and email login' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      Mobile and email login
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>
                <div className="a-card card-discover card1 col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper ">
                        <img src="./images/Multiple-Payment-Option.webp" alt='Multiple Payment Option' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      Multiple Payment Option
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>

                <div className="a-card card-discover col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper">
                        <img src="./images/2-and-4-player-system.webp" alt='2&4 player system' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      2&4 player system
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>

                <div className="a-card card-discover col-md-3">
                  <div className="card-icon-title-wrapper">
                    <div className="card__icon pb-1">
                      <div className="icon__wrapper ">
                        <img src="./images/Tournament-system.webp" alt='Tournament system' />
                      </div>
                    </div>
                    <h1 className="card__title fs-4 g-text">
                      {" "}
                      Tournament system
                    </h1>
                  </div>
                  <p className="card__description">
                    Play Metaverse using your skills and win to earn real cash. Use
                    your Metaverse expertise to earn real money instead of just using
                    it to pass time.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_ebook_sec">
          <div className="container">
            <div className="row align-items-center" id="ebook_card">
              <div className="col-lg-7 col-12">
                <h2 className="ourservice-titles-new">
                  Metaverse Development Strategies - eBook
                </h2>
                <p className="contents">
                  This eBook will unveil the secret methods &amp; strategies to
                  develop a successful metaverse project. We’ll explore the
                  essentials for Metaverse development, including the proven
                  strategies, requirements, and Development approach.
                </p>
                <div className="ebook_btn_sec">
                  <button
                    className="btn ebook_btn"
                    toggle="modal"
                    target="#met_game_ebook_popup_form_modal"
                  >
                    Free Download
                  </button>
                </div>
              </div>
              {/* <div className="img_sec">
                <img
                  src="https://www.MetaBlocktechnologies.com/asset/inner-pages-new/metaverse-game-development/ebook-img.webp"
                  alt="Metaverse Development Strategies - eBook"
                  title="Metaverse Development Strategies - eBook"
                  className="ebook_card_img img-fluid lazyload"
                />
              </div> */}
              {/* <div className="free_title_sec">
                <img
                  src="https://www.MetaBlocktechnologies.com/asset/inner-pages-new/metaverse-game-development/free-img.webp"
                  alt="Free Download"
                  title="Free Download"
                  className="free_img lazyload"
                />
              </div> */}
            </div>
          </div>
        </section>
        <section className="metaverse_game_unique">
          <div className="container">
            <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">
              Unique Characteristics of Metaverse game development
            </h2>
            <p className="contents">
              Metaverse game development gives a variety of opportunities for
              special features that might improve the user experience. Here are
              some examples of characteristics that could distinguish a
              metaverse game.
            </p>
            <div className="row justify-content-center row_line">
              <div className="col-lg-4 col-md-6 col-12 col_line">
                <div className="unique_box">
                  <img
                    src="./images/key (1).webp"
                    alt="Decentralized Ownership and economy"
                    title="Decentralized Ownership and economy"
                    className="sprite_icons lazyload"
                  />
                  <h3 className="sub_title">
                    Decentralized Ownership and economy
                  </h3>
                  <p className="sub_contents">
                    A metaverse game that uses blockchain technology can provide
                    players actual ownership over their virtual assets, allowing
                    them to purchase, sell , and trade virtual goods with other
                    players in a decentralized market.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 col_line">
                <div className="unique_box">
                  <img
                    src="./images/metaverse (1).webp"
                    alt="Integration of virtual reality technology"
                    title="Integration of virtual reality technology"
                    className="sprite_icons lazyload"
                  />
                  <h3 className="sub_title">
                    Integration of virtual reality technology
                  </h3>
                  <p className="sub_contents">
                    Using VR technology , a metaverse game can give players a
                    more engaging and immersive experience, giving them the
                    impression that they are actually inside the game world.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 col_line">
                <div className="unique_box">
                  <img
                    src="./images/user-generated-content.webp"
                    alt="User generated content"
                    title="User generated content"
                    className="sprite_icons lazyload"
                  />
                  <h3 className="sub_title">User generated content</h3>
                  <p className="sub_contents">
                    Can improve player engagement and foster a sense of
                    community by enabling users to create and share their own
                    content within the game environment such as unique avatars,
                    virtual spaces and goods.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 col_line">
                <div className="unique_box">
                  <img
                    src="./images/contract.webp"
                    alt="Dynamic and changing world"
                    title="Dynamic and changing world"
                    className="sprite_icons lazyload"
                  />
                  <h3 className="sub_title">Dynamic and changing world</h3>
                  <p className="sub_contents">
                    A metaverse game may offer a dynamic and ever-developing
                    game environment , with quests , and other activities that
                    change in response to player actions and the community's
                    evolving requirements.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 col_line">
                <div className="unique_box">
                  <img
                    src="./images/cross-platform.webp"
                    alt="Cross-platform compatibility"
                    title="Cross-platform compatibility"
                    className="sprite_icons lazyload"
                  />
                  <h3 className="sub_title">Cross-platform compatibility</h3>
                  <p className="sub_contents">
                    By enabling players to access the game from a variety of
                    devices, such as PCs, cellphones, and gaming consoles, the
                    player base and accessibility may both be increased.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 col_line">
                <div className="unique_box">
                  <img
                    src="./images/planet-earth.webp"
                    alt="Real world integration"
                    title="Real world integration"
                    className="sprite_icons lazyload"
                  />
                  <h3 className="sub_title">Real world integration</h3>
                  <p className="sub_contents">
                    Including real world events like concerts or sporting
                    contests into the game world can give players unique and
                    unforgettable experiences while providing brands with
                    marketing opportunities.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="unique_box">
                  <img
                    src="./images/artificial-intelligence.webp"
                    alt="Integration of artificial intelligence"
                    title="Integration of artificial intelligence"
                    className="sprite_icons lazyload"
                  />
                  <h3 className="sub_title">
                    Integration of artificial intelligence
                  </h3>
                  <p className="sub_contents">
                    A metaverse game can offer more realistic and difficult
                    non-player characters(NPCs), as well as dynamically produced
                    events and challenges , by integrating intelligence.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_model">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">
                  Business model for Metaverse game development
                </h2>
                <p className="contents">
                  It is crucial to have a clear business place to earn income
                  because creating metaverse game might be expensive. Several
                  prevalent business models for creating metaverse are listed
                  below:
                </p>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-6 col-12 p-lg-0">
                <img
                  style={{ width: "100%" }}
                  src="./images/metaverseman.webp"
                  alt="Business model for Metaverse game development"
                  title="Business model for Metaverse game development"
                  className="img-fluid lazyload"
                />
              </div>
              <div className="col-lg-6 col-12 pr-lg-5 p-5">
                <div className="row justify-content-center pr-lg-5">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="model_box">
                      <h3 className="sub_title">Subscriber based model</h3>
                      <p className="sub_contents">
                        Access to the games is paid for on a yearly or monthly
                        basis. This money stream is consistent, and it can
                        entice people to play the game longer.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="model_box">
                      <h3 className="sub_title">Sales of virtual goods</h3>
                      <p className="sub_contents">
                        Players can buy virtual products for their avatars
                        including clothes, accessories, and furniture. Selling
                        virtual goods with a markup is how this approach makes
                        money.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="model_box">
                      <h3 className="sub_title">In-game advertising</h3>
                      <p className="sub_contents">
                        Game developers can run advertisements to earn money. If
                        the advertisements are pertinent to the gamer and do not
                        interfere with the game, this strategy may work well.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="model_box">
                      <h3 className="sub_title">Freemium model</h3>
                      <p className="sub_contents">
                        Users can pay to access premium features or more
                        material. With this system, players can give the game a
                        shot before deciding whether to spend more money on it.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="model_box">
                      <h3 className="sub_title">NFT sales</h3>
                      <p className="sub_contents">
                        Game developers have the option to produce special
                        in-game items and sell them to users as NFTs. If the
                        products are in great demand, this strategy might bring
                        a lot of money.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="model_box">
                      <h3 className="sub_title">Model of sponsorship</h3>
                      <p className="sub_contents">
                        Game developers can work with brands to sponsor in-game
                        activities or events. This business concept can bring in
                        money while giving players interesting experiences.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_process">
          <div className="container">
            <div className="bg_title">METAVERSE</div>
            <div className="bg_title1">
              G<br />A<br />M<br />E
            </div>
            <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">Development Process For Metaverse Game</h2>
            <p className="contents">
              We should follow certain steps can be used to create a metaverse
              game.
            </p>
            <div className="row justify-content-center process_after">
              <div className="col-lg-12">
                {/* <div className="row process_list_after">
                  <div className="col-lg-6 col-md-6 col-12" />

                </div> */}
                <div className="row process_list_after">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="process_box">
                      <p className="sub_contents">
                        Next, we concentrate on the design part because the
                        gaming world should be designed to be visually
                        appealing, immersive and engaging. Usually games are
                        created with some tools like Maya, Blender, 3D Studio
                        Max.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12" />
                </div>
                <div className="row process_list_after">
                  <div className="col-lg-6 col-md-6 col-12" />
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="process_box">
                      <p className="sub_contents">
                        Next is to develop the gameplay which should be designed
                        to be fun and engaging with many challenging objectives
                        and rewards for players. This gameplay includes
                        activities like social interaction, exploration, combat,
                        and puzzles.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row process_list_after">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="process_box">
                      <p className="sub_contents">
                        Then adding social features that allow users to
                        communicate with each other in real time such as text
                        chat, voice chat, and group activities.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12" />
                </div>
                <div className="row process_list_after">
                  <div className="col-lg-6 col-md-6 col-12" />
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="process_box">
                      <p className="sub_contents">
                        After the above step, create virtual economies by
                        defining the currency and the methods by which players
                        can acquire it. you may also set-up an online market for
                        things where users can trade virtual money for real
                        goods.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row process_list_after">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="process_box">
                      <p className="sub_contents">
                        Then implement blockchain technology that provides a
                        players with a sense of ownership over their in-game
                        assets and offers security, transparency, and
                        decentralization.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12" />
                </div>
                <div className="row process_list_after">
                  <div className="col-lg-6 col-md-6 col-12" />
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="process_box">
                      <p className="sub_contents">
                        Finally, once the game was created, it is crucial to
                        test and improve it to make sure it is reliable and
                        enjoyable to play.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_clone">
          <div className="container">
            <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">List Metaverse Game Clone Scripts</h2>
            <div className="row align-items-center">
              <div className="col-lg-4 col-md-12 col-12 pr-lg-0">
                <div className="clone_list_sec">
                  <div className="clone_list">
                    <img
                      src="./images/vr-glasses (1).webp"
                      alt="Clone List"
                      title="Clone List"
                      className="img-fluid lazyload"
                    />
                    <div className="sub_title">Alien worlds clone script</div>
                  </div>
                  <div className="clone_list">
                    <img
                      src="./images/vr-glasses (1).webp"
                      alt="Clone List"
                      title="Clone List"
                      className="img-fluid lazyload"
                    />
                    <div className="sub_title">Sorare clone script</div>
                  </div>
                  <div className="clone_list">
                    <img
                      src="./images/vr-glasses (1).webp"
                      alt="Clone List"
                      title="Clone List"
                      className="img-fluid lazyload"
                    />
                    <div className="sub_title">Decentraland clone</div>
                  </div>
                  <div className="clone_list">
                    <img
                      src="./images/vr-glasses (1).webp"
                      alt="Clone List"
                      title="Clone List"
                      className="img-fluid lazyload"
                    />
                    <div className="sub_title">Neondis clone script</div>
                  </div>
                  <div className="clone_list">
                    <img
                      src="./images/vr-glasses (1).webp"
                      alt="Clone List"
                      title="Clone List"
                      className="img-fluid lazyload"
                    />
                    <div className="sub_title">Sandbox clone script</div>
                  </div>
                  <div className="clone_list">
                    <img
                      src="./images/vr-glasses (1).webp"
                      alt="Clone List"
                      title="Clone List"
                      className="img-fluid lazyload"
                    />
                    <div className="sub_title">Horizon worlds clone script</div>
                  </div>
                  <div className="clone_list">
                    <img
                      src="./images/vr-glasses (1).webp"
                      alt="Clone List"
                      title="Clone List"
                      className="img-fluid lazyload"
                    />
                    <div className="sub_title">Second Life clone script</div>
                  </div>
                  <div className="clone_list">
                    <img
                      src="./images/vr-glasses (1).webp"
                      alt="Clone List"
                      title="Clone List"
                      className="img-fluid lazyload"
                    />
                    <div className="sub_title">Ember sword clone script</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-12 pl-0">
                <img
                  src="./images/unity-3d-developmet.webp"
                  alt="List Metaverse Game Clone Scripts"
                  title="List Metaverse Game Clone Scripts"
                  // className="img-fluid lazyload"
                  style={{ width: "500px" }}
                />
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_category">
          <div className="container">
            <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">
              Different categories of Metaverse Games we develop
            </h2>
            <p className="contents">
              With the knowledge of various trending blockchain networks and
              also tech stacks we work on the following categories.
            </p>
            <div className="row align-items-center justify-content-center category_box">
              <div className="col-lg-7 col-12"></div>
              <div className="col-lg-5 col-md-12 col-12">

                <div className="row justify-content-center">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="category_list">
                      <img
                        src="./images/map.webp"
                        alt="Adventure"
                        title="Adventure"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Adventure</div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="category_list">
                      <img
                        src="./images/chequered-flag.webp"
                        alt="Racing"
                        title="Racing"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Racing</div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="category_list">
                      <img
                        src="./images/clapperboard.webp"
                        alt="Action"
                        title="Action"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Action</div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="category_list">
                      <img
                        src="./images/video.webp"
                        alt="Simulation"
                        title="Simulation"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Simulation</div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="category_list">
                      <img
                        src="./images/trophy.webp"
                        alt="Sports"
                        title="Sports"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Sports</div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="category_list">
                      <img
                        src="./images/cards.webp"
                        alt="Casino"
                        title="Casino"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Casino</div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="category_list">
                      <img
                        src="./images/puzzle.webp"
                        alt="Puzzle"
                        title="Puzzle"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Puzzle</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_industry">
          <div className="container">
            <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">
              Exploring Metaverse Game Development Services for the various
              Industries
            </h2>
            <p className="contents">
              The following enterprise-focused solutions are what we offer to
              assist organizations access the metaverse.
            </p>
            <div className="row justify-content-center">
              {/* <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                <div className="industry_box">
                  <div className="sub_title">Real-estate</div>
                  <img
                    src="./images/icons8-real-estate-48.webp"
                    alt="Real-estate"
                    title="Real-estate"
                    className="sprite_icons lazyload"
                  />
                </div>
              </div> */}
              <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                <div className="industry_box">
                  <div className="sub_title">Gaming</div>
                  <img
                    src="./images/industryIcons-CDNAR1PE.webp"
                    alt="Gaming"
                    title="Gaming"
                    className="sprite_icons lazyload"
                    style={{ objectPosition: "-109px 0px" }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                <div className="industry_box">
                  <div className="sub_title">Fashion</div>
                  <img
                    src="./images/industryIcons-CDNAR1PE.webp"
                    alt="Fashion"
                    title="Fashion"
                    className="sprite_icons lazyload"
                    style={{ objectPosition: "-218px 0px" }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                <div className="industry_box">
                  <div className="sub_title">Entertainment</div>
                  <img
                    src="./images/industryIcons-CDNAR1PE.webp"
                    alt="Entertainment"
                    title="Entertainment"
                    className="sprite_icons lazyload"
                    style={{ objectPosition: "-327px 0px" }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                <div className="industry_box">
                  <div className="sub_title">Social media</div>
                  <img
                    src="./images/industryIcons-CDNAR1PE.webp"
                    alt="Social media"
                    title="Social media"
                    className="sprite_icons lazyload"
                    style={{ objectPosition: "-436px 0px" }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                <div className="industry_box">
                  <div className="sub_title">Tourism</div>
                  <img
                    src="./images/industryIcons-CDNAR1PE.webp"
                    alt="Tourism"
                    title="Tourism"
                    className="sprite_icons lazyload"
                    style={{ objectPosition: "-545px 0px" }}
                  />
                </div>
              </div>
              {/* <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                <div className="industry_box">
                  <div className="sub_title">Ecommerce</div>
                  <img
                    src="./images/icons8-add-shopping-cart-50.webp"
                    alt="Ecommerce"
                    title="Ecommerce"
                    className="sprite_icons lazyload"
                    style={{ objectPosition: "-545px 0px" }}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </section>
        <section className="metaverse_game_techstack">
          <div className="container-fluid">
            <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">Tech Stack we use</h2>
            <div className="row justify-content-center" id="techstack_box">
              <div className="col-lg-10">
                <div className="row justify-content-center">
                  <div className="col-lg-2 col-md-2 col-6">
                    <div className="techstack_list">
                      <img
                        src="./images/bitcoins123.webp"
                        alt="Blockchain"
                        title="Blockchain"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Blockchain</div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-6">
                    <div className="techstack_list">
                      <img
                        src="./images/virtual-reality (1).webp"
                        alt="AR/VR"
                        title="AR/VR"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">AR/VR</div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-6">
                    <div className="techstack_list">
                      <img
                        src="./images/hologram.webp"
                        alt="3D reconstruction"
                        title="3D reconstruction"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">3D reconstruction</div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-6">
                    <div className="techstack_list">
                      <img
                        src="./images/artificial-intelligence (1).webp"
                        alt="Artificial Intelligence"
                        title="Artificial Intelligence"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Artificial Intelligence</div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-6">
                    <div className="techstack_list">
                      <img
                        src="./images/iot.webp"
                        alt="Spatial computing"
                        title="Spatial computing"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">Spatial computing</div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-6">
                    <div className="techstack_list">
                      <img
                        src="./images/about-img12 (2).webp"
                        alt="IoT (internet of things)"
                        title="IoT (internet of things)"
                        className="sprite_icons lazyload"
                      />
                      <div className="sub_title">IoT (internet of things)</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_hire">
          <div className="container-fluid">
            <h2 style={{ color: '#BD3AFF' }} className="ourservice-titles-new">Hire Metaverse Game Developers</h2>
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-6 col-md-12 col-12 pl-lg-5">
                <div className="pl-lg-5">
                  <p className="contents">
                    MetaBlock continually strives to enhance the metaverse
                    environment and its associated platforms with the help of a
                    certified team of Metaverse game developers. Our creative
                    team is working as a metaverse game developer to include
                    numerous cutting-edge elements in the metaverse games in an
                    effort to increase innovation in the gaming industry. The
                    purpose of the metaverse games is to increase player
                    interaction with the game.MetaBlock works on enhancing the
                    graphics and metaverse surroundings so that the metaverse
                    game will have better visuals and interactivity and attract
                    more active participants.
                  </p>
                  <p className="contents">
                    The MetaBlock team creates your game platform from scratch in
                    accordance with your game strategy, and as a metaverse game
                    designer, we utilize a variety of blockchain-related
                    technological stacks and tools to provide the game's
                    participants with the greatest visuals possible.
                    Additionally, the MetaBlock professionals concentrate on
                    enhancing the value of your company portfolio by creating a
                    platform with distinctive features and a variety of
                    eye-catching visuals that appeal to users of the online
                    world. Hire our skilled metaverse game developers and talk
                    about your original ideas for adding to the gaming
                    environment in the real world.
                  </p>
                  <div className="metaverse_game_btn_sec">
                    <button
                      toggle="modal"
                      target="#popup_form_modal"
                      className="btn BtnPrimry TlkBtn metaverse_game_btn"
                    >
                      <span>
                        {/* <img
                          src="./images/"
                          alt="enquiry"
                          loading="eager"
                          className="img-fluid lazyload mr-2 lazyload"
                        /> */}
                        Get A Live Demo
                      </span>
                      <span>
                        {/* <img
                          // src="https://www.MetaBlocktechnologies.com/asset/home-page-new//images/btn-call-icon.gif"
                          alt="enquiry"
                          loading="eager"
                          className="img-fluid lazyload mr-2 lazyload"
                        /> */}
                        Get A Live Demo
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 p-lg-0">
                <img
                  style={{ width: "90%" }}
                  src="./images/about-img12 (1).webp"
                  alt="Hire Metaverse Game Developers"
                  title="Hire Metaverse Game Developers"
                  className="img-fluid lazyload"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="metaverse_game_whydo">
          <div className="container">
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-12 col-12">
                {/* <div className="img_sec">
                  <img
                    src="./images/vr-glasses (1).webp"
                    alt="Why do you need MetaBlock for Metaverse Game development ?"
                    title="Why do you need MetaBlock for Metaverse Game development ?"
                    className="img-fluid lazyload"
                  />
                </div> */}
                <div className="why_do_box">
                  <h2 style={{ color: '#BD3AFF', marginTop: '5vh' }} className="ourservice-titles-new">
                    Why do you need MetaBlock for Metaverse Game development ?
                  </h2>
                  <p className="contents">
                    MetaBlock, one of the top creators of Metaverse games from India,
                    is now working on creating a futuristic game with
                    cutting-edge features. MetaBlock has a team of more than 50
                    skilled developers at its disposal. The experts at MetaBlock have
                    a wealth of knowledge on the current blockchain ecosystem,
                    which includes Ethereum, Binance Smart Chain, Solana,
                    Cardano, Polygon, and others.
                  </p>
                  <p className="contents">
                    MetaBlock will help you start your metaverse game and allow you
                    to establish your presence in the virtual world with full
                    knowledge of the Metaverse development. Launching your game
                    now will give you a chance to be a part of the future gaming
                    empire as the Metaverse gaming community soars to incredible
                    heights in the coming years.MetaBlock has successfully created
                    more than 200 platforms in the blockchain industry for
                    clients all over the world. Contact MetaBlock professionals and
                    turn your virtual game into a reality.
                  </p>
                  <h3 className="sub_title">
                    Our potential benefits in metaverse game development are:
                  </h3>
                  <div className="row justify-content-center">
                    <div className="col-lg-4 col-12">
                      <div className="whydo_list">
                        <img
                          src="./images/vr-glasses (1).webp"
                          alt="Game-Pad"
                          title="Game Pad"
                          className="img-fluid lazyload"
                        />
                        <h4 className="sub_contents">
                          Cross-Platform Development
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-4 col-12">
                      <div className="whydo_list">
                        <img
                          src="./images/vr-glasses (1).webp"
                          alt="Game-Pad"
                          title="Game Pad"
                          className="img-fluid lazyload"
                        />
                        <h4 className="sub_contents">
                          Budget Friendly Innovation
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-4 col-12">
                      <div className="whydo_list">
                        <img
                          src="./images/vr-glasses (1).webp"
                          alt="Game-Pad"
                          title="Game Pad"
                          className="img-fluid lazyload"
                        />
                        <h4 className="sub_contents">Proven Track Record</h4>
                      </div>
                    </div>
                    <div className="col-lg-4 col-12">
                      <div className="whydo_list">
                        <img
                          src="./images/vr-glasses (1).webp"
                          alt="Game-Pad"
                          title="Game Pad"
                          className="img-fluid lazyload"
                        />
                        <h4 className="sub_contents">Customization</h4>
                      </div>
                    </div>
                    <div className="col-lg-4 col-12">
                      <div className="whydo_list">
                        <img
                          src="./images/vr-glasses (1).webp"
                          alt="Game-Pad"
                          title="Game Pad"
                          className="img-fluid lazyload"
                        />
                        <h4 className="sub_contents">Immersive Media</h4>
                      </div>
                    </div>
                    <div className="col-lg-4 col-12">
                      <div className="whydo_list">
                        <img
                          src="./images/vr-glasses (1).webp"
                          alt="Game-Pad"
                          title="Game Pad"
                          className="img-fluid lazyload"
                        />
                        <h4 className="sub_contents">Ongoing Support</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default MetaverseGame;
